var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// libs
import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
// includes
import { fetchConfigsApi } from '@/includes/api/config';
// hooks
import useBreadcrumb from '@/hooks/useBreadcrumb';
// widgets
import Breadcrumbs from '@/widgets/Breadcrumbs/Breadcrumbs';
import { Header } from '@/widgets/Header';
// stores
import useConfigStore from '@/stores/Configs';
import useAccountStore from '@/stores/account';
// widgets
import AccountBootstrap from './widgets/AccountBootstrap';
import PermissionsWrapper from './widgets/PermissionsWrapper';
// helpers
import { isBoolean, isString } from '@/helpers/utils';
export default function Instamart() {
    const { setCities, setCampaignOpDisabled, setCampaignOpDisabledCallout } = useConfigStore((state) => ({
        setCities: state.setCities,
        setCampaignOpDisabled: state.setCampaignOpDisabled,
        setCampaignOpDisabledCallout: state.setCampaignOpDisabledCallout,
    }));
    const breadcrumbConfig = useBreadcrumb();
    const { user } = useAccountStore((state) => ({
        user: state.user,
    }));
    useEffect(() => {
        fetchConfig();
    }, []);
    const fetchConfig = () => __awaiter(this, void 0, void 0, function* () {
        const result = yield fetchConfigsApi('IM_ENABLED_CITIES,CAMPAIGN_OP_DISABLED,CAMPAIGN_OP_DISABLED_CALLOUT');
        const { config } = result || {};
        if (config) {
            config.IM_ENABLED_CITIES && setCities(config.IM_ENABLED_CITIES);
            isBoolean(config.CAMPAIGN_OP_DISABLED) &&
                setCampaignOpDisabled(config.CAMPAIGN_OP_DISABLED);
            isString(config.CAMPAIGN_OP_DISABLED_CALLOUT) &&
                setCampaignOpDisabledCallout(config.CAMPAIGN_OP_DISABLED_CALLOUT);
        }
    });
    return (React.createElement(React.Fragment, null,
        React.createElement(Header, { user: user }),
        React.createElement(AccountBootstrap, null,
            React.createElement(Breadcrumbs, { crumbs: breadcrumbConfig.crumbs }),
            React.createElement(PermissionsWrapper, null,
                React.createElement(Outlet, null)))));
}
